import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { TemplateType } from '../../models/template-type.enum';
import { TemplateReferenceService } from '../../services/template-reference.service';

@Component({
  selector: 'spv2-template-reference',
  templateUrl: './template-reference.component.html',
  styleUrls: ['./template-reference.component.css']
})
export class TemplateReferenceComponent {

  @Input() templateType: TemplateType;
  @ViewChild('content') templateRef: TemplateRef<any>;
  
  constructor(private templateReferenceService: TemplateReferenceService) { }

  ngAfterViewInit() {
    if(this.templateType === TemplateType.SubMenu) {
      this.templateReferenceService.addLinkTemplate(this.templateRef);

      return;
    } 
    this.templateReferenceService.addTemplate(this.templateType ,this.templateRef);
  }

  ngOnDestroy() {
    if(this.templateType === TemplateType.SubMenu) {
      this.templateReferenceService.resetLink();
    }
  }
}
